import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import sanitizeHtml from 'sanitize-html';
import { Drawer, Input, Form } from 'antd';
import { DrawerExplanation } from '../../components/editor/DrawerExplanation';

const FormItem = Form.Item;

// https://developer.mixpanel.com/docs/javascript

export class AnalyticsDrawer extends React.Component {
  state = {
    anaGoogleIdValidateStatus: 'success',
    anaGoogleIdHelp: null,

    anaMixpanelIdValidateStatus: 'success',
    anaMixpanelIdHelp: null,

    anaKissmetricsIdValidateStatus: 'success',
    anaKissmetricsIdHelp: null,
  };

  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    analytics: PropTypes.object.isRequired,
    onAnalyticsIdChange: PropTypes.func.isRequired,
  };

  anaGoogleIdChanged = throttle((value) => {
    const sanitized = sanitizeHtml(value.trim(), {
      allowedTags: [],
      allowedAttributes: {},
    });
    if (sanitized.length === 0) {
      this.setState({
        anaGoogleIdValidateStatus: 'success',
        anaGoogleIdHelp: 'Blank means no tracking',
      });
    }
    else if (sanitized.length > 0 && sanitized.length < 8) {
      this.setState({
        anaGoogleIdValidateStatus: 'warning',
        anaGoogleIdHelp: 'Too short',
      });
    }
    else {
      this.setState({
        anaGoogleIdValidateStatus: 'success',
        anaGoogleIdHelp: null,
      });
    }
    this.props.onAnalyticsIdChange('anaGoogleId', sanitized);
  }, 500);

  anaMixpanelIdChanged = throttle((value) => {
    const sanitized = sanitizeHtml(value.trim(), {
      allowedTags: [],
      allowedAttributes: {},
    });
    if (sanitized.length === 0) {
      this.setState({
        anaMixpanelIdValidateStatus: 'success',
        anaMixpanelIdHelp: 'Blank means no tracking',
      });
    }
    else if (sanitized.length > 0 && sanitized.length < 8) {
      this.setState({
        anaMixpanelIdValidateStatus: 'warning',
        anaMixpanelIdHelp: 'Too short',
      });
    }
    else {
      this.setState({
        anaMixpanelIdValidateStatus: 'success',
        anaMixpanelIdHelp: null,
      });
    }
    this.props.onAnalyticsIdChange('anaMixpanelId', sanitized);
  }, 500);

  anaKissmetricsIdChanged = throttle((value) => {
    const sanitized = sanitizeHtml(value.trim(), {
      allowedTags: [],
      allowedAttributes: {},
    });
    if (sanitized.length === 0) {
      this.setState({
        anaKissmetricsIdValidateStatus: 'success',
        anaKissmetricsIdHelp: 'Blank means no tracking',
      });
    }
    else if (sanitized.length > 0 && sanitized.length < 8) {
      this.setState({
        anaKissmetricsIdValidateStatus: 'warning',
        anaKissmetricsIdHelp: 'Too short',
      });
    }
    else {
      this.setState({
        anaKissmetricsIdValidateStatus: 'success',
        anaKissmetricsIdHelp: null,
      });
    }
    this.props.onAnalyticsIdChange('anaKissmetricsId', sanitized);
  }, 500);

  render() {
    const {
      anaGoogleId, anaMixpanelId, anaKissmetricsId,
    } = this.props.analytics;
    const {
      anaGoogleIdValidateStatus, anaGoogleIdHelp,
      anaMixpanelIdValidateStatus, anaMixpanelIdHelp,
      anaKissmetricsIdValidateStatus, anaKissmetricsIdHelp,
    } = this.state;

    return (
      <Drawer
        title="Analytics"
        placement="right"
        className="editor__drawer"
        closable={true}
        onClose={this.props.onClose}
        visible={this.props.visible}
        width={300}
      >

        <DrawerExplanation
          title="Google Analytics"
          explanation={
            'Tells PageHits which Google property to send analytics data to. ' +
            'Google property ID is a string like UA-000000-2.'
          }
        />
        <FormItem
          validateStatus={anaGoogleIdValidateStatus}
          hasFeedback={false}
          help={anaGoogleIdHelp}
        >
          <Input
            onChange={(e) => { this.anaGoogleIdChanged(e.target.value); }}
            defaultValue={anaGoogleId}
            placeholder="Your Google tracking ID"
          />
        </FormItem>

        <DrawerExplanation
          title="Mixpanel token"
          explanation="Tells PageHits which Mixpanel account to send analytics data to."
        />
        <FormItem
          validateStatus={anaMixpanelIdValidateStatus}
          hasFeedback={false}
          help={anaMixpanelIdHelp}
        >
          <Input
            onChange={(e) => { this.anaMixpanelIdChanged(e.target.value); }}
            defaultValue={anaMixpanelId}
            placeholder="Your Mixpanel token"
          />
        </FormItem>

        <DrawerExplanation
          title="Kissmetrics ID"
          explanation="Tells PageHits which Kissmetrics account to send analytics data to."
        />
        <FormItem
          validateStatus={anaKissmetricsIdValidateStatus}
          hasFeedback={false}
          help={anaKissmetricsIdHelp}
        >
          <Input
            onChange={(e) => { this.anaKissmetricsIdChanged(e.target.value); }}
            defaultValue={anaKissmetricsId}
            placeholder="Your Kissmetrics ID"
          />
        </FormItem>

      </Drawer>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/AnalyticsDrawer.jsx